import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../css/CardComponent.css";

const CardComponent = () => {
  const a = [1, 2, 3, 4, 5, 6, 7, 8, 9];
  const [hoverId, setHoverId] = useState(-1);
  const navigate = useNavigate();
  return (
    <div className="container mt-3">
      <h5 style={{ marginTop: 10 }}>Trending Holidays</h5>
      <div className="row">
        {a.map((val, ind) => (
          <div className="col-sm-3 pl-0 pr-0">
            <div
              className="card mb-3"
              style={{
                borderLeft: 1,
                borderRight: 1,
                borderLeftStyle: "dashed",
                borderRightStyle: "dashed",
              }}
              onMouseEnter={() => {
                setHoverId(ind);
              }}
              onMouseLeave={() => {
                setHoverId(-1);
                document.getElementById("test").style.display = "";
              }}
            >
              {hoverId === ind ? (
                <>
                  <img
                    id="close"
                    src="https://images.pexels.com/photos/368260/pexels-photo-368260.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260"
                    className="card-img-top images"
                    alt="..."
                    style={{ cursor: "pointer", height: 300 }}
                    // onClick={() => {
                    //   navigate("/package-details", {
                    //     state: {
                    //       id: ind,
                    //     },
                    //   });
                    // }}
                    onMouseEnter={() => {
                      document.getElementById("test").style.display = "";
                      document.getElementById("close").style.opacity = 0.3;
                    }}
                  />
                  <div
                    id="test"
                    className="middle"
                    style={{ cursor: "pointer" }}
                    onMouseEnter={() =>
                      (document.getElementById("close").style.opacity = 0.3)
                    }
                  >
                    <div className="text">Buy Now</div>
                  </div>
                </>
              ) : (
                <img
                  src="https://images.pexels.com/photos/789381/pexels-photo-789381.jpeg?cs=srgb&dl=pexels-riciardus-789381.jpg&fm=jpg"
                  className="card-img-top"
                  alt="..."
                  style={{ cursor: "pointer", height: 300 }}
                  // onClick={() => {
                  //   navigate("/package-details", {
                  //     state: {
                  //       id: ind,
                  //     },
                  //   });
                  // }}
                />
              )}
              <div
                className="card-body"
                onMouseMove={() => {
                  document.getElementById("test").style.display = "none";
                  document.getElementById("close").style.opacity = 1;
                }}
              >
                <h5 className="card-title">Card title</h5>
                <p className="card-text">
                  This is a wider card with supporting text below as a natural
                  lead-in to additional content. This content is a little bit
                  longer.
                </p>
                <p className="card-text">
                  <small className="text-muted">Last updated 3 mins ago</small>
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CardComponent;
